export class LanguageKeys {
  public MESSAGES = ({ count }: { count: number; }) => {
    return count === 1 ? `${count} Message` : `${count} Messages`;
  };

  public Page = 'Page';
  public GoTo = 'Go to';
  public PerPage = '/ Page';
  public Logout = "Logout";
  public Cancel = "Cancel";
  public Close = 'Close';
  public Add = 'Add';

  public UploadImage = 'Upload Image'

}

export type LangProps = keyof LanguageKeys;
export default LanguageKeys;
